// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d2if5","textarea":"styles_textarea__96rsO"};